export default {
  data() {
    return {
      //上传excel的地址
      action: this.baseUrl + "resources/excel_topic?token=" + this.$store.state.authority_management,
      //上传的批量注册excel文件储存
      fileList: [],
      //更改试卷名字的弹窗
      dialogExamUpdateVisible: false,
      //更新单道题目的索引值
      updateSingleIndex: 0,
      //辨别更新还是添加的文字
      singleText: '',
      //辨别弹窗是修改还是增加,0是添加，1是修改
      windowType: 0,
      //试卷总数量
      totalPage: 0,
      //新增试卷的名字
      testName: '',
      //请求的数量
      resourceLength: 15,
      //分页偏移量
      offset: 0,
      //当前页数
      currentPage: 1,
      //搜索的字符串
      keywordName: '',
      //试题资源
      tableData: [
        {
          id: 123,
          name: "attean",
          type: "单选"
        }
      ],
      // 控制对话显示
      dialogTestVisible: false,
      //配置试题的弹窗
      dialogExamVisible: false,
      //添加单条试题或者修改单体试题
      dialogSingleVisible: false,
      //添加或者修改单道题目的对象
      singleExamObj: {
        name: '',
        type: '',
        options: '',
        answer: '',
      },
      //添加单道题目时候的选项
      options: [{
        value: '判断',
        label: '判断'
      }, {
        value: '单选',
        label: '单选'
      }, {
        value: '多选',
        label: '多选'
      }],
      formLabelWidth: "120px",
      //试卷的试题数组
      examArr: [],
      //更新试卷需要的id和name
      examObj: {}
    }
  },
  methods: {
    confirmAddSourse() {

    },
    onSearch() {
      let offset = 0;
      let length = this.resourceLength
      let data = { token: this.$store.state.authority_management, id: this.keywordId, name: this.keywordName, offset: offset, length: length, type: 2 };
      // 这里调用搜索资源接口
      this.$post('resources/shop_search', data).then(res => {
        // // console.log(res)
        this.tableData = res.data.result.data
        this.totalPage = res.data.result.total
		this.currentPage = 1

      })
    },
    //改变请求的页面
    handleSizeChange(val) {
      this.resourceLength = val;
      this.getData();
    },
    //弹出更改试卷名字弹窗
    updateExamName(obj) {
      // // console.log(obj);
      this.examObj = obj;
      // // console.log(this.examObj);
      this.dialogExamUpdateVisible = true;
    },
    //确定更改名字
    confirmExamName() {
      let data = {
        token: this.$store.state.authority_management,
        name: this.examObj.name,
        type: '2',
        id: this.examObj.id,
        data: this.examObj.data
      };
      if (this.examObj.name == undefined || this.examObj.name == '') {
        this.$message({
          showClose: true,
          message: '请填写正确的提示名字!',
          type: 'error',
        })
        return false;
      }
      this.$post('resources/shop_edit', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            showClose: true,
            message: '试题名更改成功！',
            type: 'success',
          })
          this.dialogExamUpdateVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: '试题名更改失败！',
            type: 'error',
          })
        }
      })
    },
    //删除整张试卷
    deleteExam(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post('resources/delete', { token: this.$store.state.authority_management, id: id }).then(res => {
          if (res.data.status == 'success') {
            this.$message({
              showClose: true,
              message: '删除成功！',
              type: 'success',
            })
            this.getData();
          } else {
            this.$message({
              showClose: true,
              message: '删除失败！',
              type: 'error',
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    //习题配置
    examConfig(obj) {
      // // console.log(obj);
      this.examObj.id = obj.id;
      this.examObj.name = obj.name;
      obj.data == '{}' ? this.examArr = [] : this.examArr = JSON.parse(obj.data);
      this.dialogExamVisible = true;
      // let data = { token: this.$store.state.id, id: id, type: 2, offset: 0, length: 999 };
      // let data = { token: token, id: id, type: 2, offset: offset, length: length }
      // this.$post('resources/get', data).then(res => {
      //   // console.log(JSON.parse(res.data.result.data));
      //   this.examArr = JSON.parse(res.data.result.data);
      // })
    },
    //确认习题配置
    confirmConfig() {
      let data = {
        token: this.$store.state.authority_management,
        name: this.examObj.name,
        type: '2',
        id: this.examObj.id,
        data: JSON.stringify(this.examArr)
      }
      // // console.log(data);
      this.$post('resources/shop_edit', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            showClose: true,
            message: '题目配置成功！',
            type: 'success',
          })
          this.dialogExamVisible = false;
          this.getData();
        } else {
          this.$message({
            showClose: true,
            message: '题目配置失败！',
            type: 'danger',
          })
        }
      })
    },
    //弹框是否删除某一道题目
    deleteExams(id) {
      this.examArr.splice(id, 1);
    },



    //弹框编辑某一道题目
    updateExams(scope) {
      this.singleText = '修改题目',
        this.windowType = 1;
      this.dialogSingleVisible = true;
      // // console.log(scope);
      this.updateSingleIndex = scope.$index;
      let obj = scope.row;
      let options = '';
      let answer = '';
      for (let val of obj.options) {
        options += val.toString() + '#';
      }
      for (let val of obj.answer) {
        answer += val.toString() + '#';
      }
      this.singleExamObj.name = obj.name;
      this.singleExamObj.type = obj.type;
      this.singleExamObj.options = options;
      this.singleExamObj.answer = answer;

    },
    //弹窗添加单道题目
    addSingleWindow() {
      this.singleText = '添加题目',
        this.windowType = 0;
      this.dialogSingleVisible = true;
      this.singleExamObj = {
        name: '',
        type: '',
        options: '',
        answer: '',
      }
    },
    //确定添加一道习题
    confirmSingle() {
      if (this.singleExamObj.name == '') {
        this.$message({
          showClose: true,
          message: '题目名字不能为空！',
          type: 'error',
        })
        return false;
      } else if (this.singleExamObj.type == '') {
        this.$message({
          showClose: true,
          message: '题目类型不能为空！',
          type: 'error',
        })
        return false;
      } else if (this.singleExamObj.options == '') {
        this.$message({
          showClose: true,
          message: '题目选项不能为空！',
          type: 'error',
        })
        return false;
      } else if (this.singleExamObj.answer == '') {
        this.$message({
          showClose: true,
          message: '题目答案不能为空！',
          type: 'error',
        })
        return false;
      }
      let optionsArr = this.singleExamObj.options.split('#');
      let answerArr = this.singleExamObj.answer.split('#');
      optionsArr = optionsArr.splice(0, optionsArr.length - 1);
      answerArr = answerArr.splice(0, answerArr.length - 1);
      switch (this.singleExamObj.type) {
        case '判断':
          if (optionsArr.length != 2) {
            this.$message({
              showClose: true,
              message: '题目选项不是2个或者格式错误！',
              type: 'error',
            })
            return false;
          } else if (answerArr.length != 1) {
            this.$message({
              showClose: true,
              message: '答案不是一个或者格式错误',
              type: 'error',
            })
            return false;
          } else if (optionsArr.indexOf(answerArr[0]) == -1) {
            this.$message({
              showClose: true,
              message: '答案并不在选项之中，请注意答案是否对应选项中的一个！',
              type: 'error',
            })
            return false;
          }
          break;
        case '单选':
          if (optionsArr.length < 2) {
            this.$message({
              showClose: true,
              message: '题目选项少于2个或者格式错误！',
              type: 'error',
            })
            return false;
          } else if (answerArr.length != 1) {
            this.$message({
              showClose: true,
              message: '答案不是一个或者格式错误',
              type: 'error',
            })
            return false;
          } else if (optionsArr.indexOf(answerArr[0]) == -1) {
            this.$message({
              showClose: true,
              message: '答案并不在选项之中，请注意答案是否对应选项中的一个！',
              type: 'error',
            })
            return false;
          }
          break;
        case '多选':
          if (optionsArr.length < 2) {
            this.$message({
              showClose: true,
              message: '题目选项少于2个或者格式错误！',
              type: 'error',
            })
            return false;
          } else if (answerArr.length < 1) {
            this.$message({
              showClose: true,
              message: '答案没有填写或者格式错误',
              type: 'error',
            })
            return false;
          }
          for (let val of answerArr) {
            if (optionsArr.indexOf(val) == -1) {
              this.$message({
                showClose: true,
                message: '答案并不在选项之中，请注意答案是否对应选项中的一个！',
                type: 'error',
              })
              return false;
            }
          }
          break;
        default:
      }
      let obj = {
        name: this.singleExamObj.name,
        type: this.singleExamObj.type,
        options: optionsArr,
        answer: answerArr
      };
      // // console.log(obj);
      if (this.windowType == 0) {
        this.examArr.push(obj);
        this.$message({
          showClose: true,
          message: '添加单道题目成功,记得在题目配置页面保存才会生效！',
          type: 'success',
        })
      } else {
        // Vue.set(this.examArr, this.updateSingleIndex, obj)
        this.examArr.splice(this.updateSingleIndex, 1, obj);
        this.$message({
          showClose: true,
          message: '修改单道题目成功,记得在题目配置页面保存才会生效！',
          type: 'success',
        })
      }
      //关闭弹窗
      this.dialogSingleVisible = false;
      //清空表单对象
      this.singleExamObj = {
        name: '',
        type: '',
        options: '',
        answer: '',
      }
    },
    //获取所有数据
    getData() {
      let token = this.$store.state.authority_management
      let data = { token: token, type: 2, name: this.keywordName, offset: this.offset, length: this.resourceLength }
      this.$post('resources/shop_search', data).then(res => {
        this.tableData = res.data.result.data;
        this.totalPage = res.data.result.total;
      })
    },
    //点击分页展示数据
    handleCurrentChange(index) {
      this.offset = (index - 1) * this.resourceLength;
      this.currentPage = index;
      this.getData();
    },
    //创建一个新的试题资源
    createTestSourse() {
      this.$post('resources/shop_create', { token: this.$store.state.authority_management, name: this.testName, data: JSON.stringify({}), type: '2' }).then(res => {
        if (res.data.status) {
          this.$message({
            showClose: true,
            message: '创建试题成功',
            type: 'success'
          });
          this.dialogTestVisible = false;
          this.getData();
          this.testName = '';
        } else {
          this.$message({
            showClose: true,
            message: '创建试题失败',
            type: 'danger'
          });
        }
      })
    },

    // 上传excel批量导入习题
    httpreq(q) {
      this.$upload(this.action, q).then(res => {
        this.$message({
          message: '批量导入完成',
          type: 'success'
        });
      })
    },

    //上传excel批量注册的三个方法
    //上传前
    beforeUpload(file) {
      let str = file.name;
      if (str.substr(str.length - 4, 4).toLocaleLowerCase() != "xlsx") {
        alert('excel文件必须是xlsx格式')
        return false;
      }
    },
    //上传超出数量限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    //上传移除
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    // this.tableData.map((item)=>{
    //   item.type = "习题"
    // })
    // handleSizeChange(val) {
    //   // console.log(`每页 ${val} 条`);
    //   this.resourceLength = val;  
    // },
    // handleCurrentChange(val) {
    //   // console.log(`当前页: ${val}`);
    //   this.currentPage = val;
    //   this.offset = (val-1)*this.resourceLength;
    //   this.getData();
    //   },
  },
  created() {
    this.getData();
  }
}